import { Tooltip } from 'react-tooltip';
import { BrowserRouter } from 'react-router-dom';
import { Slide, ToastContainer } from 'react-toastify';

import { Provider } from 'react-redux';
import InitiateStoreContainer from './containers/InitiateStoreContainer';

import { Spinner } from '@moovly/ui';
import useAuth from './hooks/auth';
import useI18n from './hooks/i18n';
import Router from './Router';
import store from './store';

import 'react-toastify/dist/ReactToastify.css';
import { checkClientForStaging } from './modules/staging';
import { ThemingWrapper } from '@moovly/whitelabel';

checkClientForStaging();
function App() {
  const { authChecked, isAuthenticated } = useAuth();

  const loaded = useI18n({ isAuthenticated });
  if (!loaded || !authChecked) return <Spinner />;

  return (
    <Provider store={store}>
      <BrowserRouter>
        <InitiateStoreContainer isAuthenticated={isAuthenticated}>
          <Tooltip id="default-tooltip" place="left" />
          <ToastContainer
            position="bottom-center"
            autoClose={5000}
            transition={Slide}
            newestOnTop={false}
            closeOnClick={false}
            rtl={false}
            limit={1}
            pauseOnFocusLoss
            draggable={false}
            theme="dark"
          />

          <ThemingWrapper>
            <Router isLoggedIn={isAuthenticated} />
          </ThemingWrapper>
        </InitiateStoreContainer>
      </BrowserRouter>
      <Tooltip id="default-tooltip" place="left" />
    </Provider>
  );
}

export default App;
